import React, { useEffect, useState } from "react";
import { getAssessments, createAssessment } from "@/lib/api";
import { PageHeader, StatusChip } from "@/components/dashboard/ui";
import { Plus, FileText, CheckCircle2, X } from "lucide-react";
import { toast } from "sonner";

export default function Assessments() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", category: "", patient: "", severity: "Mild" });
  const load = () => getAssessments().then(setList);
  useEffect(() => { load(); }, []);
  const save = async () => {
    if (!form.name || !form.patient) { toast.error("Name and patient required"); return; }
    try { await createAssessment({ ...form, status: "Completed" }); toast.success("Assessment added"); setOpen(false); setForm({ name: "", category: "", patient: "", severity: "Mild" }); load(); } catch { toast.error("Failed"); }
  };
  return (
    <div className="fade-in max-w-4xl">
      <PageHeader title="Assessments & Screeners" subtitle="Standardized pediatric behavioral health screeners" action={<button data-testid="add-assessment" onClick={() => setOpen(true)} className="btn-primary px-5 py-2.5 font-semibold inline-flex items-center gap-2"><Plus size={18} /> New Assessment</button>} />
      <div className="card-soft p-2">
        {list.map((a) => (
          <div key={a.id} className="flex items-center gap-4 px-4 py-3.5 rounded-2xl hover:bg-[#f6f9fe]">
            <span className="h-11 w-11 rounded-2xl bg-[#eef5ff] grid place-items-center text-[#1a5fd0]"><FileText size={20} /></span>
            <div className="flex-1"><div className="text-[15px] font-bold text-[#10233f]">{a.name} <span className="text-slate-400 font-medium">({a.category})</span></div><div className="text-[12.5px] text-slate-400">{a.patient} · {a.date}</div></div>
            <span className="flex items-center gap-1 text-[13px] font-semibold text-[#2f9e57]"><CheckCircle2 size={15} /> {a.status}</span>
            <StatusChip status={a.severity} />
          </div>
        ))}
      </div>
      {open && (
        <div className="fixed inset-0 z-50 grid place-items-center bg-black/40 p-4" onClick={() => setOpen(false)}>
          <div className="card-soft w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4"><h3 className="font-display text-[20px] font-bold text-[#10233f]">New Assessment</h3><button onClick={() => setOpen(false)}><X size={20} className="text-slate-400" /></button></div>
            <div className="space-y-3">
              {[["name", "Screener (e.g. M-CHAT)"], ["category", "Category (e.g. Autism)"], ["patient", "Patient name"]].map(([k, label]) => (
                <div key={k}><label className="text-sm font-semibold text-[#10233f]">{label}</label><input data-testid={`assessment-${k}`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="mt-1.5 w-full card-soft px-4 py-2.5 outline-none" style={{ borderRadius: 12 }} /></div>
              ))}
              <div><label className="text-sm font-semibold text-[#10233f]">Result</label>
                <select value={form.severity} onChange={(e) => setForm({ ...form, severity: e.target.value })} className="mt-1.5 w-full card-soft px-4 py-2.5 outline-none" style={{ borderRadius: 12 }}>{["Low Risk", "Mild", "Moderate"].map((o) => <option key={o}>{o}</option>)}</select></div>
            </div>
            <button data-testid="save-assessment" onClick={save} className="btn-primary w-full mt-5 py-3 font-semibold">Save</button>
          </div>
        </div>
      )}
    </div>
  );
}
